import { Loader } from "@sazka/design-system/src/loader/loader";
import { startPanicButtonFlow } from "@sazka/ng/panic-button/core/self-exclusion";
import { useRgLimitsPopup } from "@sazka/ng/rg-limits/use-rg-limits-popup";
import { invokeWithLogin } from "@sazka/ng/utils/invoke-with-login";
import { UrlUtils } from "@sazka/utils/url";
import { useCookieStorage } from "@sazka/utils/use-storage";
import { useIdentityVerificationPopup } from "../components/identity-verification/use-identity-verification-popup";
import { useChat } from "../components/master-page/use-chat";

interface DeeplinkItem {
    name: string;
    handler: (value?: string) => void;
}
const deepLinks: DeeplinkItem[] = [];

const addDeepLinkHandler = (name: DeeplinkItem["name"], handler: DeeplinkItem["handler"]) => {
    deepLinks.push({ name, handler });
};

addDeepLinkHandler("show-chat", async (val: string) => {
    if (val !== "true") return;
    useChat().show();
});

addDeepLinkHandler("aff", async (val: string) => {
    const storage = useCookieStorage();
    storage.setItem(`aff`, val, "analytics", { expires: 14 });
});

addDeepLinkHandler("panic-button", async (val: string) => {
    if (val !== "true") return;

    await invokeWithLogin(startPanicButtonFlow);
});

addDeepLinkHandler("rg-limits", async (val: string) => {
    if (val !== "true") return;
    const { showRgPopup } = useRgLimitsPopup();

    await showRgPopup();
});

addDeepLinkHandler("dl", async (val: string) => {
    Loader.show();
    if (val === "identity-verification") {
        const { showIdentityVerificationPopup } = useIdentityVerificationPopup();
        await showIdentityVerificationPopup();
    }
    Loader.hide();
});

export const handleDeepLinks = () => {
    deepLinks.forEach((x) => {
        const val = UrlUtils.getQueryString(x.name);
        if (val === null || val === undefined) return;
        x.handler(val);
        UrlUtils.clearUrlParam(x.name);
    });
};
